import { CloudErrors, FlowjoCommons } from '@portal/portal-core';

const { Alerts } = FlowjoCommons;

export const STATIC_SERVER_REACHABLE = 'STATIC_SERVER_REACHABLE';
export const STATIC_SERVER_UNREACHABLE = 'STATIC_SERVER_UNREACHABLE';
export const CLIENT_NETWORK_OFFLINE = 'CLIENT_NETWORK_OFFLINE';
export const CLIENT_NETWORK_ONLINE = 'CLIENT_NETWORK_ONLINE';

export const configurableStyling = {
  alertHeaderDefaultTitle: 'Alerts',
  noticeHeaderDefaultTitle: 'Notices',
  alertHeaderBackgroundColor: '#146878',
  alertTopBackgroundColor: '#146878',
  headerColor: 'white',
  headerFontSize: '.8em',
  alertHeaderHeight: '22px',
  alertTopHeaderHeight: '22px',
  alertOutlineColor: '#146878',
  alertTopOutlineColor: '#146878',
};

interface AlertTranslation {
  message: string;
  title: string | null;
  timeoutValue: number | null;
  dismiss: boolean | null;
  showDismissChild: boolean | null;
}

// Minimal store shape: these helpers only dispatch actions onto the redux store.
interface AlertStore {
  dispatch: (action: unknown) => unknown;
}

export function alertTranslator(alertType: string | null): AlertTranslation {
  switch (alertType) {
    case null:
      return {
        message: 'Unidentified error.',
        title: null,
        timeoutValue: 5000,
        dismiss: true,
        showDismissChild: true,
      };
    case CloudErrors.cloudErrorTypes.CONNECTION_PROBLEM:
      return {
        message: 'Unable to reach the user service. Waiting to reconnect ...',
        title: 'Network Alert',
        timeoutValue: null,
        dismiss: null,
        showDismissChild: null,
      };
    case CLIENT_NETWORK_OFFLINE:
      return {
        message: 'Offline. Waiting to reconnect ....',
        title: 'Network Alert',
        timeoutValue: null,
        dismiss: null,
        showDismissChild: null,
      };
    default:
      return {
        message: 'Unidentified error.',
        title: null,
        timeoutValue: 3000,
        dismiss: true,
        showDismissChild: null,
      };
  }
}

export function alertUiContainerIdentifier(alertType: string | null): string | null {
  switch (alertType) {
    case null:
      return 'alertBottom';
    case CloudErrors.cloudErrorTypes.CONNECTION_PROBLEM:
      return 'alertBottom';
    case CLIENT_NETWORK_OFFLINE:
      return 'alertBottom';
    case STATIC_SERVER_UNREACHABLE:
      return 'alertBottom';
    case 'UNIDENTIFIED_ERROR':
      return 'alertBottom';
    default:
      return null;
  }
}

export const staticServerReachable = function staticServerReachable(store: AlertStore): void {
  const action = Alerts.AlertActions.dismissAlert(STATIC_SERVER_UNREACHABLE);
  store.dispatch(action);
};

export const staticServerUnreachable = function staticServerUnreachable(store: AlertStore): void {
  const alert = Alerts.Alert.AlertStamp({
    id: STATIC_SERVER_UNREACHABLE,
    date: null,
    type: STATIC_SERVER_UNREACHABLE,
  });
  const action = Alerts.AlertActions.setAlert(alert);
  store.dispatch(action);
};

export const clientNetworkOnline = function clientNetworkOnline(store: AlertStore): void {
  const action = Alerts.AlertActions.dismissAlert(CLIENT_NETWORK_OFFLINE);
  store.dispatch(action);
};

export const clientNetworkOffline = function clientNetworkOffline(store: AlertStore): void {
  const alert = Alerts.Alert.AlertStamp({
    id: CLIENT_NETWORK_OFFLINE,
    date: null,
    type: CLIENT_NETWORK_OFFLINE,
  });
  const action = Alerts.AlertActions.setAlert(alert);
  store.dispatch(action);
};

export function checkClientNetwork(store: AlertStore): void {
  if (navigator && navigator.onLine === false) {
    clientNetworkOffline(store);
  } else if (navigator && navigator.onLine === true) {
    clientNetworkOnline(store);
  }
}

export const checkClientNetworkPoll = function checkClientNetworkPoll(
  store: AlertStore,
  checkCycle = 5 * 1000,
): void {
  (function cycleCheckClientNetworkPoll() {
    checkClientNetwork(store);
    setTimeout(cycleCheckClientNetworkPoll, checkCycle);
  })();
};

export function serviceConnectionAlert(store: AlertStore): void {
  const alert = Alerts.Alert.AlertStamp({
    id: CloudErrors.cloudErrorTypes.CONNECTION_PROBLEM,
    date: null,
    type: CloudErrors.cloudErrorTypes.CONNECTION_PROBLEM,
  });
  const action = Alerts.AlertActions.setAlert(alert);
  store.dispatch(action);
}
